import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { ProfileCompletionEvent, TabClickEvent } from '@planone/bau365/util-fair-data';

import * as DataAccessUserPageActions from './data-access-user.page.actions';

@Injectable()
export class DataAccessUserPageFacade {
  constructor(private readonly store: Store) {}

  tabClicked(tabClickInfo: TabClickEvent) {
    this.store.dispatch(DataAccessUserPageActions.tabClicked(tabClickInfo));
  }

  profileCompleted(profileCompletion: ProfileCompletionEvent) {
    this.store.dispatch(DataAccessUserPageActions.profileCompletion(profileCompletion));
  }
}
